/**
 * The reserved team value meaning "the operator was on no team".
 *
 * A sentinel rather than a separate control, so "No team" sits in the team
 * picker beside the real teams and travels to the API the same way they do.
 * It cannot collide with a Firestore document id, which is alphanumeric.
 *
 * Deliberately distinct from a task whose teams were never established: that
 * one has no `team_ids` at all and matches neither a team nor this. Absent
 * means unknown; empty means checked and none.
 */
export const NO_TEAM = '__none__';
